import { FeatureFlags } from 'FeatureFlags';
import { useFeatureFlag } from 'configcat-react';
import { useEffect, useState } from 'react';

export enum TabOptions {
  TimeWindows = 'All Time Windows',
  CalculationTrace = 'Calculation Trace',
}

const contentTabListDefault: Array<TabOptions> = [TabOptions.TimeWindows];

export const useTabsContent = () => {
  const [contentTabList, setContentTabList] = useState(contentTabListDefault);
  const {
    value: isCalculationTraceEnabledValue,
    loading: isCalculationTraceEnabledLoading,
  } = useFeatureFlag(FeatureFlags.CALC_TRACE_ENABLED, false);

  useEffect(() => {
    if (
      isCalculationTraceEnabledValue &&
      !isCalculationTraceEnabledLoading &&
      contentTabList
    ) {
      setContentTabList(
        contentTabListDefault.concat(TabOptions.CalculationTrace)
      );
    }
  }, []);

  return contentTabList;
};
